import { useId, useState } from "react";

const useCollapsibleContent = () => {
    const id = useId();
    const [expanded, setExpanded] = useState(true);

    const toggleExpandedState = () => setExpanded((prev) => !prev);

    return {
        expanded,
        toggle: toggleExpandedState,
        triggerProps: {
            "aria-controls": id,
            "aria-expanded": expanded,
        },
        expandableContentProps: {
            id: id,
            "aria-hidden": !expanded,
        },
    };
};

export default useCollapsibleContent;
